import Vue from 'vue'

import appMixin from './app'
import authMixin from './auth'
import loaderMixin from './loader'

Vue.mixin(appMixin)
Vue.mixin(authMixin)
Vue.mixin(loaderMixin)
